import { IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Group from '@material-ui/icons/Group';
import Person from '@material-ui/icons/Person';
import PowerOff from '@material-ui/icons/PowerOff';
import React from 'react';
import { withUsuario } from '../contexts/UsuarioContext';
import { logout } from '../util/keycloak.js';

const styles = theme => ({
  menuItem: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& $primary, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
  icon: {},
  button: {
    margin: theme.spacing(1),
  },
});

class Logout extends React.Component {

  state = {
    anchorEl: null,
  }

  handleClickMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  };

  handleChangeMenu = async (index) => {
    this.setState({ anchorEl: null });
    if (index === 2) {
      logout();
    }
  };

  render () {
    const menuOptions = [{
      index: 0,
      icon: <Person />,
      primaryText: <div>
        <Typography style={{ fontSize: 13, fontWeight: 'bold', whiteSpace: 'initial' }}>{this.props.nomeUsuario}</Typography>
        <Typography style={{ fontSize: 12 }}>{this.props.codigoUsuario}</Typography>
        </div>,
      visible: true,
    },
    {
      index: 1,
      icon: <Group />,
      primaryText: <div>
            { this.props.roles.length > 0 ?
              <Typography style={{ whiteSpace: 'initial', fontSize: 13 }}>{this.props.roles.join(", ")}</Typography>
            : null
            }
            </div>
      ,
      visible: true,
    },
    {
      index: 2,
      icon: <PowerOff />,
      primaryText: 'Sair...',
      visible: true,
    }
  ];
    const { classes } = this.props;
    const ITEM_HEIGHT = 48;
    const open = Boolean(this.state.anchorEl);
    return (
      <React.Fragment>
        <IconButton variant='raised'
          id={'menuButton'}
          color='inherit'
          aria-label='More'
          aria-owns={open ? 'long-menu' : null}
          aria-haspopup='true'
          onClick={this.handleClickMenu}
        >
          <AccountCircle />
        </IconButton>
        <Menu
          id='long-menu'
          anchorEl={this.state.anchorEl}
          open={open}
          onClose={this.handleCloseMenu}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: 250,
            },
          }}
        >
          {menuOptions.map(option =>
            option.visible && <MenuItem disabled={option.disabled} key={option.index} onClick={() => this.handleChangeMenu(option.index)}>
              <ListItemIcon className={classes.icon}>
                {option.icon}
              </ListItemIcon>
              {option.primaryText}
            </MenuItem>
          )}
        </Menu>
      </React.Fragment>
    );
  }
}

export default withUsuario(withStyles(styles)(Logout));
